import React from 'react';
import SettingsLayout from './SettingsLayout';
import SavedInterviewersSection from './SavedInterviewersSection';

/**
 * /hirewithus/settings/interviewers — the Saved Interviewers directory,
 * rendered inside the unified Settings shell so the left sub-nav rail and
 * page header are consistent with every other settings section.
 */
const SavedInterviewersPage = () => {
  return (
    <SettingsLayout
      activeKey="interviewers"
      title="Settings"
      description="Manage your company profile, interview panel, and recruiter access."
    >
      <SavedInterviewersSection />
    </SettingsLayout>
  );
};

export default SavedInterviewersPage;
